import React from 'react';
import PropTypes from 'prop-types';
//! This is a temporary workaround for lacking iconography
//! Built in Iconography should be removed in favor of a Vistaprint Icon Library when available.

const CheckMarkCircle = ({
  style = {},
  fill = '#05A34A',
  width = '64',
  height = '64',
  className = '',
  viewBox = '0 0 64 64',
}) => (
  <svg
    width={width}
    style={style}
    className={className}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32 0C23.5117 0 15.3737 3.37067 9.37301 9.37301C3.37032 15.373 0 23.5117 0 32C0 40.4883 3.37067 48.6263 9.37301 54.627C15.373 60.6297 23.5117 64 32 64C40.4883 64 48.6263 60.6293 54.627 54.627C60.6297 48.627 64 40.4883 64 32C63.9893 23.5172 60.616 15.3839 54.6161 9.38394C48.616 3.38391 40.4828 0.0109227 32 0ZM48.4482 22.9117L27.136 44.2027C26.832 44.528 26.424 44.7387 25.984 44.8C25.8507 44.8267 25.7147 44.84 25.5787 44.8427C25.464 44.8507 25.3467 44.8347 25.2373 44.8C24.7973 44.7387 24.3893 44.528 24.0853 44.2027L15.552 35.6905C15.152 35.2932 14.928 34.7518 14.928 34.1865C14.928 33.6212 15.152 33.0798 15.552 32.6825C16.3894 31.8505 17.744 31.8505 18.5813 32.6825L25.621 39.7222L45.4183 19.9037C46.2557 19.0717 47.6103 19.0717 48.4477 19.9037C48.8477 20.301 49.0717 20.8424 49.0717 21.4077C49.0717 21.973 48.8477 22.5143 48.4477 22.9117H48.4482Z"
      fill={fill}
    />
  </svg>
);

export default CheckMarkCircle;

CheckMarkCircle.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string,
};
